var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.routeName},[_c('Header'),_vm._v(" "),_c('main',{staticClass:"flex items-stretch justify-between",style:(("min-height: calc(100vh - " + _vm.footerHeight + "px)"))},[_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }